import React, { useEffect, useState } from 'react'
import { Col, FlexboxGrid, Message, Panel, Stack, toaster, Toggle, Uploader } from 'rsuite'
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import globalIP from '@/GlobelIP';


const CommenAuth = () => {
  const [compnm, setCompnm] = useState('');
  const [id, setId] = useState(1);
  const [authorised, setAuthorised] = useState(false);
  const [isBulkUpdate, setIsBulkUpdate] = useState(false);
  const [bhide, setBhide] = useState(false);
  const [wmark, setWmark] = useState(false);
  const [wcata, setWCata] = useState(false);
  const [wqut, setWqut] = useState(false);
  const [fini, setFini] = useState(false);
  const [sort, setSort] = useState(false);
  const [cdime, setCdime] = useState(false);
  const [costingno, setCostingno] = useState(1);
  const [bulkCata, setBulkCata] = useState(false);
  const [downloadAllImg, setDownloadAllImg] = useState(false);
  const [packagingBulkUpload, setPackagingBulkUpload] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details?populate=*`);
      const json = await response.json();
      setCompnm(json.data[0].attributes.cmpnm);
      setAuthorised(json.data[0].attributes.Authorised);
      setBhide(json.data[0].attributes.BulkHide);
      setWmark(json.data[0].attributes.WMark);
      setWCata(json.data[0].attributes.Wcataloue);
      setWqut(json.data[0].attributes.Wqutation);
      setFini(json.data[0].attributes.setFinish);
      setIsBulkUpdate(json.data[0].attributes.isBulkUpdateProduct);
      setSort(json.data[0].attributes.SortBy);
      setCdime(json.data[0].attributes.CostingDimesnion);
      setBulkCata(json.data[0].attributes.BulkCatalogue);
      setDownloadAllImg(json.data[0].attributes.DownloadAllImage);
      setPackagingBulkUpload(json.data[0].attributes.PackagingBulkUpload);
      setId(json.data[0].id);
      if (json.data[0].attributes.WaterMark?.data) {
        const imageUrl = json.data[0].attributes.WaterMark.data.attributes.url;
        setFileInfo1({ WaterMark: `${globalIP}${imageUrl}` });
      }
      setCostingno(json.data[0].attributes.CostingNo || 1)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleToggleCostingNo = async () => {

    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              CostingNo: costingno == 1 || null ? 2 : 1
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update Bulk status.');
      }
      setCostingno(costingno == 1 || null ? 2 : 1)
    } catch (error) {
      console.error('Error updating Bulk status:', error);
    }
  };

  const [fileInfo1, setFileInfo1] = useState({
    WaterMark: null
  });
  const handleImageUpload = async fileList => {
    if (fileList.length > 0) {
      const file = fileList[fileList.length - 1];
      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        toaster.push(
          <Message showIcon type="error">
            Please upload a jpg/jpeg/png file
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const formData = new FormData();
      const updatedCdata = {};
      formData.append('data', JSON.stringify(updatedCdata));
      formData.append('files.WaterMark', file.blobFile);
      if (file.blobFile) {
        try {
          // Update WaterMark field in API
          await fetch(`${globalIP}/api/company-details/${id}`, {
            method: 'PUT',
            body: formData
          });
          fetchData();
          toaster.push(
            <Message showIcon type="success">
              Image Uploaded Successfully
            </Message>,
            { placement: 'topCenter' }
          );
        } catch (error) {
          console.error('Error uploading image:', error);
        }
      }
    }
  };
  const handleToggleChange = async () => {
    const updatedValue = !authorised;
    setAuthorised(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              Authorised: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update Authorised status.');
      }
    } catch (error) {
      console.error('Error updating Authorised status:', error);
    }
  };
  const handleToggleBulkUpdateChange = async () => {
    const updatedValue = !isBulkUpdate;
    setIsBulkUpdate(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              isBulkUpdateProduct: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update Authorised status.');
      }
    } catch (error) {
      console.error('Error updating Authorised status:', error);
    }
  };
  const handleTogglebulk = async () => {
    const updatedValue = !bhide;
    setBhide(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              BulkHide: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update Bulk status.');
      }
    } catch (error) {
      console.error('Error updating Bulk status:', error);
    }
  };
  const handleToggleWmark = async () => {
    const updatedValue = !wmark;
    setWmark(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              WMark: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update WMark status.');
      }
    } catch (error) {
      console.error('Error updating WMark status:', error);
    }
  };
  const handleToggleWcata = async () => {
    const updatedValue = !wcata;
    setWCata(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              Wcataloue: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update Wcata status.');
      }
    } catch (error) {
      console.error('Error updating Wcata status:', error);
    }
  };
  const handleToggleWqut = async () => {
    const updatedValue = !wqut;
    setWqut(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              Wqutation: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update Wqut status.');
      }
    } catch (error) {
      console.error('Error updating Wqut status:', error);
    }
  };
  const handleTogglesefin = async () => {
    const updatedValue = !fini;
    setFini(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              setFinish: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update finish status.');
      }
    } catch (error) {
      console.error('Error updating finish status:', error);
    }
  };
  const handleTogglesesort = async () => {
    const updatedValue = !sort;
    setSort(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              SortBy: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update Sort status.');
      }
    } catch (error) {
      console.error('Error updating Sort status:', error);
    }
  };
  const handleTogglecodim = async () => {
    const updatedValue = !cdime;
    setCdime(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              CostingDimesnion: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update CDime status.');
      }
    } catch (error) {
      console.error('Error updating CDime status:', error);
    }
  };
  const handleToggleCata = async () => {
    const updatedValue = !bulkCata;
    setBulkCata(updatedValue); // Update state immediately for better UX
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${id}`, // Replace 1 with the dynamic company ID if needed
        {
          method: 'PUT', // or PATCH if partial update
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              BulkCatalogue: updatedValue
            }
          })
        }
      );
      if (!response.ok) {
        console.error('Failed to update CDime status.');
      }
    } catch (error) {
      console.error('Error updating CDime status:', error);
    }
  };

  const handleToggleDownloadImg = async () => {
    const updatedValue = !downloadAllImg;
    setDownloadAllImg(updatedValue);
    await fetch(`${globalIP}/api/company-details/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: { DownloadAllImage: updatedValue } })
    });
  };

  const handleTogglePackagingBulk = async () => {
    const updatedValue = !packagingBulkUpload;
    setPackagingBulkUpload(updatedValue);
    await fetch(`${globalIP}/api/company-details/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: { PackagingBulkUpload: updatedValue } })
    });
  };

  return (
    <>
      <FlexboxGrid justify="start">
        <FlexboxGrid.Item as={Col} colspan={24} md={12}>
          <Panel header="Product" bordered>
            <Stack justifyContent="space-between">
              <Stack direction="column" alignItems="flex-start">
                <b>Bulk Update</b>
                <Toggle checked={isBulkUpdate} onChange={handleToggleBulkUpdateChange} />
              </Stack>
            </Stack>
          </Panel>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={12}>
          <Panel header="Company" bordered>
            <Stack justifyContent="space-between">
              <b>{compnm}</b>
              <Stack direction="column" alignItems="flex-start">
                <b>Authorised</b>
                <Toggle checked={authorised} onChange={handleToggleChange} />
              </Stack>
            </Stack>
          </Panel>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginBottom: '5px' }}>
          <Panel header="Company" bordered>
            <Stack justifyContent="space-between">
              <b>{compnm}</b>
              <Stack direction="column" alignItems="flex-start">
                <b>Bulk Costing</b>
                <Toggle checked={bhide} onChange={handleTogglebulk} />
                <b>SA Costing</b>
                <Toggle checked={costingno == 2} onChange={handleToggleCostingNo} />
              </Stack>
            </Stack>
          </Panel>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={12}>
          <Panel bordered>
            <Stack
              justifyContent="space-between"
              alignItems="flex-start"
              direction="row"
            >
              <Stack direction="column">
                <b>Water Mark</b>
                <Toggle checked={wmark} onChange={handleToggleWmark} />
                <b>Catalogue</b>
                <Toggle checked={wcata} onChange={handleToggleWcata} />
                <b>Quotation</b>
                <Toggle checked={wqut} onChange={handleToggleWqut} />
              </Stack>
              {wmark && (
                <Uploader
                  onChange={e => handleImageUpload(e)}
                  fileListVisible={false}
                  accept="image/jpeg,image/jpg,image/png"
                  listType="picture"
                  action={''}
                >
                  <button style={{ width: 120, height: 120 }}>
                    {fileInfo1.WaterMark ? (
                      <img src={fileInfo1.WaterMark} width="100%" height="100%" />
                    ) : (
                      <CameraRetroIcon style={{ fontSize: 80 }} />
                    )}
                  </button>
                </Uploader>
              )}
            </Stack>
          </Panel>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={12}>
          <Panel header="Company" bordered>
            <Stack justifyContent="space-between">
              <b>Set Finish</b>
              <Toggle checked={fini} onChange={handleTogglesefin} />
            </Stack>
          </Panel>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={12}>
          <Panel header="Company" bordered>
            <Stack justifyContent="space-between">
              <b>Sort By</b>
              <Toggle checked={sort} onChange={handleTogglesesort} />
            </Stack>
          </Panel>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={12}>
          <Panel header="Company" bordered>
            <Stack justifyContent="space-between">
              <b>Costing Dimension</b>
              <Toggle checked={cdime} onChange={handleTogglecodim} />
            </Stack>
          </Panel>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginTop: '5px' }}>
          <Panel header="Company" bordered>
            <Stack justifyContent="space-between">
              <b>Bulk Catalogue</b>
              <Toggle checked={bulkCata} onChange={handleToggleCata} />
            </Stack>
          </Panel>
        </FlexboxGrid.Item>

        <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginTop: '5px' }}>
          <Panel header="Company" bordered>
            <Stack justifyContent="space-between">
              <b>Download All Image</b>
              <Toggle checked={downloadAllImg} onChange={handleToggleDownloadImg} />
            </Stack>
          </Panel>
        </FlexboxGrid.Item>

        <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginTop: '5px' }}>
          <Panel header="Company" bordered>
            <Stack justifyContent="space-between">
              <b>Packaging Bulk Upload</b>
              <Toggle checked={packagingBulkUpload} onChange={handleTogglePackagingBulk} />
            </Stack>
          </Panel>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </>
  )
}

export default CommenAuth
